export default __webpack_public_path__ + "static/media/cagayan-cert.703823c1.webp";